var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "HongKong-map",
    attrs: { id: "HongKong-map" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }